import React from 'react'
import { cn } from 'src/lib/utils'

interface EmptyStateProps {
  image: string
  message: string
  action: React.ReactNode
  theme?: 'light' | 'dark'
}

export const EmptyState = ({ image, message, action, theme = 'dark' }: EmptyStateProps): React.ReactElement => {
  const textColor = theme === 'light' ? 'text-primary-gray' : 'text-ivory'

  return (
    <div>
      <p className={cn('font-roboto-condensed-medium', textColor)}>{message}</p>
      <div className="relative flex items-center justify-center min-h-[270px] w-full overflow-hidden rounded-md">
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover z-0" />
        <div className="relative z-10">{action}</div>
      </div>
    </div>
  )
}
